import { getImagePath, isObjectNotEmpty } from "../CommonUtils"

export function getDealPicture(dealData) {
    if (isObjectNotEmpty(dealData['i']) && dealData['i']['p'])
        return {
            preview: true, url: dealData['i']['p'],
            thumbnail: dealData['i']['t'] ? dealData['i']['t'] : dealData['i']['p']
        }
    else return {
        preview: false,
        thumbnail: getImagePath('/images/deals/noDealThumbnail.png'),
        url: getImagePath('/images/deals/noDealImage.png')
    }
}

export function getDealPicturesList(dealData) {
    if (isObjectNotEmpty(dealData['i'])) {
        var imageList = [];
        ['p', 'b', 'f'].forEach((orientation) => {
            if (dealData['i'][orientation])
                imageList.push({ imageUrl: dealData['i'][orientation] })
        })
        return imageList
    }
    else return []
}

export function getDealSavingPercent(deal) {
    return deal?.discount ?? deal?.dl ?? ''
}

export function getDealOfferPrice(deal) {
    // retailPrice
    return deal?.offerPrice ?? deal?.rp
}

export function getDealMRP(deal) {
    let value = deal?.price ?? deal?.mrp
    if (typeof value == 'number')
        return value
    else if (typeof value == 'object' && value.price)
        return value.price/value.su

    // last resort.
    return deal?.offerPrice ?? deal?.rp ?? 0
}

export function getDealDataForCart(deal) {
    let mmid = deal?.mmid ?? deal?.omg?.mmid
    let dealId = deal?.dealId ?? deal?.omg?.dealId

    let price = getDealMRP(deal)
    let offerPrice = getDealOfferPrice(deal)
    let discount = getDealSavingPercent(deal)

    let _deal = {
        dealId: dealId, mmid: mmid,
        index: deal?.index, quantity: deal?.quantity ? deal.quantity: 0,
        offerPrice: offerPrice, price: price, discount: discount
    }

    if (deal?.omg && isObjectNotEmpty(deal.omg)) return { ...deal.omg, ..._deal }
    else return { ...deal, ..._deal }
}